var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Input',{ref:"input",staticClass:"html-snippet",attrs:{"id":_vm.name,"type":"textarea","name":_vm.name,"label":_vm.label,"readonly":true,"value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }